import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { Provedores } from '@/app/providers';
import { roteador } from '@/app/router';

// A ordem importa: primitivos, semanticos, temas e por fim o base, que consome
// os tokens declarados acima.
import '@/app/tokens/primitivos.css';
import '@/app/tokens/semanticos.css';
import '@/app/tokens/tema-claro.css';
import '@/app/tokens/tema-escuro.css';
import '@/app/tokens/base.css';

const raiz = document.getElementById('root');

if (raiz === null) {
  throw new Error('Elemento #root nao encontrado em index.html.');
}

createRoot(raiz).render(
  <StrictMode>
    <Provedores>
      <RouterProvider router={roteador} />
    </Provedores>
  </StrictMode>,
);
